/**
 * Build-time configuration. Vite types `import.meta.env` as an index
 * signature, so it is read once here and re-exported with a real type rather
 * than bracket-indexed at every call site.
 */
const raw: Record<string, string | undefined> = import.meta.env;

/** Cloudflare custom domains are separate origins, so defaults must stay paired. */
export const apiBaseForHost = (hostname: string): string => {
  switch (hostname) {
    case "app.vakilat.io":
      return "https://api.vakilat.io";
    case "staging.app.vakilat.io":
      return "https://staging.api.vakilat.io";
    case "localhost":
    case "127.0.0.1":
      return "http://localhost:8787";
    default:
      return "";
  }
};

export const API_BASE_URL: string =
  raw["VITE_API_URL"] ?? apiBaseForHost(globalThis.location?.hostname ?? "");
